import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AdvanceDataTable from '@/components/core/advance-data-table/advance-data-table';
import { useServerTable } from '@/hooks/use-server-table';
import { mergeWhere } from '@/lib/table-query';
import { createSubmissionsTableColumns } from '../../components/submissions-table/submissions-table-columns';
import { DEFAULT_MY_SURVEY_SUBMISSIONS_ORDER } from '../../graphql/queries';
import { useGetMySurveySubmissions } from '../../hooks/use-submissions';
import { SurveySubmission, SurveySubmissionsPagingResult } from '../../types/submission.types';
import { PageHeader } from '@/components/core';

export const SubmissionsListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { pagination, order, columnWhere, tableProps } = useServerTable({
    pageSize: 15,
    defaultOrder: DEFAULT_MY_SURVEY_SUBMISSIONS_ORDER,
  });

  const { data, isLoading, error } = useGetMySurveySubmissions({
    pageNo: pagination.pageIndex + 1,
    pageSize: pagination.pageSize,
    filter: mergeWhere({}, columnWhere),
    order,
  });
  const result = (data as { SurveySubmissions?: SurveySubmissionsPagingResult })?.SurveySubmissions;
  const items = result?.items ?? [];
  const totalCount = result?.totalCount ?? 0;

  const columns = createSubmissionsTableColumns({
    t,
    onOpen: (submission: SurveySubmission) =>
      navigate(`/hr/survey-my-submissions/${submission.ItemId}`),
  });

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader title={t('MY_SURVEYS')} />

      <AdvanceDataTable
        {...tableProps}
        data={items}
        columns={columns}
        isLoading={isLoading}
        error={error instanceof Error ? error : null}
        pagination={{
          pageIndex: pagination.pageIndex,
          pageSize: pagination.pageSize,
          totalCount,
        }}
        isExpandRowContent={false}
        mobileView="cards"
      />
    </div>
  );
};
